import React from 'react';
import './BookingDetailsModal.css';
import api from '../api';

const BookingDetailsModal = ({ date, bookings, onClose, onUpdate }) => {
    const handleCancelReservation = async (bookingId) => {
        if (!window.confirm('Cancel the entire reservation/workorder?')) {
            return;
        }

        try {
            await api.put(`/admin/bookings/${bookingId}/cancel`, {
                reason: 'Admin canceled reservation.'
            });

            alert('Reservation canceled successfully.');
            onUpdate();
        } catch (error) {
            console.error('Failed to cancel reservation:', error);

            if (error.response && error.response.data) {
                alert(error.response.data);
            } else {
                alert('Failed to cancel reservation.');
            }
        }
    };

    const handleCancelItem = async (bookingId) => {
        if (!window.confirm('Cancel only this item from the reservation?')) {
            return;
        }

        try {
            await api.put(`/admin/bookings/${bookingId}/cancel-item`, {
                reason: 'Admin canceled item.'
            });

            alert('Item canceled successfully.');
            onUpdate();
        } catch (error) {
            console.error('Failed to cancel item:', error);

            if (error.response && error.response.data) {
                alert(error.response.data);
            } else {
                alert('Failed to cancel item.');
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Bookings on {new Date(date).toLocaleDateString()}</h2>
                <button className="close-button" onClick={onClose}>
                    Close
                </button>
                <table className="bookings-table">
                    <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Rental Dates</th>
                        <th>Item Id</th>
                        <th>Customer Email</th>
                        <th>Number of Rental Nights</th>
                        <th>Total Price</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {bookings.map((booking) => (
                        <tr key={booking.id}>
                            <td>{booking.customerName}</td>
                            <td>
                                {booking.startDate} to {booking.endDate}
                            </td>
                            <td>{booking.item.itemId}</td>
                            <td>{booking.customerEmail}</td>
                            <td>{booking.rentalDays}</td>
                            <td>${booking.totalPrice.toFixed(2)}</td>
                            <td>
                                <button onClick={() => handleCancelItem(booking.id)}>
                                    Cancel Item
                                </button>

                                <button
                                    onClick={() => handleCancelReservation(booking.id)}
                                    style={{marginLeft: '0.5rem'}}
                                >
                                    Cancel Reservation
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BookingDetailsModal;